import { validateEmailAddress } from "@smartsuite/email-validation";
import normalizeUrl from "normalize-url";
export const allowedProtocols = [
    "http",
    "https",
    "ftp",
    "ftps",
    "mailto",
    "tel",
    "callto",
    "sms",
    "cid",
    "xmpp",
];
// From DOMPurify
// https://github.com/cure53/DOMPurify/blob/main/src/regexp.ts
const ATTR_WHITESPACE = /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g; // eslint-disable-line no-control-regex
export function getCurrentLinkData(state) {
    const { $cursor } = state.selection;
    if (!$cursor) {
        return null;
    }
    const link = state.doc.nodeAt($cursor.pos);
    if (!link) {
        return null;
    }
    const mark = getMark(link, state.schema.marks.link);
    if (!mark) {
        return null;
    }
    const from = $cursor.pos - $cursor.textOffset;
    const to = from + link.nodeSize;
    return { from, to, mark };
}
function getMark(node, markType) {
    return node.marks.find((m) => m.type === markType);
}
export function isExternalLink(link) {
    return !link.startsWith("#");
}
export function shouldAddProtocolPrefix(link) {
    const regExp = /^https?:\/\//i;
    return !regExp.exec(link);
}
export function normalizeLink(link) {
    // handle internal link (e.g. for toc) and email link
    if (link.startsWith("#") || link.startsWith("mailto:")) {
        return link;
    }
    if (link.includes("@") && validateEmailAddress(link)) {
        return `mailto:${link}`;
    }
    try {
        return normalizeUrl(link, {
            removeTrailingSlash: false,
            stripWWW: false,
        });
    }
    catch (_a) {
        return link;
    }
}
export const isValidProtocol = (link) => {
    const allowedProtocols = ["http:", "https:"];
    // eslint-disable-next-line n/no-unsupported-features/node-builtins
    return allowedProtocols.includes(new URL(link).protocol);
};
export const isValidLinkStructure = (tokens) => {
    if (tokens.length === 1) {
        return tokens[0].isLink;
    }
    if (tokens.length === 3 && tokens[1].isLink) {
        return ["()", "[]"].includes(tokens[0].value + tokens[2].value);
    }
    return false;
};
export const isAllowedUri = (uri) => {
    return (uri.replace(ATTR_WHITESPACE, "").match(new RegExp(
    // eslint-disable-next-line no-useless-escape
    `^(?:(?:${allowedProtocols.join("|")}):|[^a-z]|[a-z0-9+.\-]+(?:[^a-z+.\-:]|$))`, "i")) !== null);
};
